
/**
 * What the disconnect banner should say about the next attempt.
 *
 * The countdown floors at zero and the attempt itself happens at the end of the delay, so a
 * literal render spends most of an outage saying "retrying in 0s" — which promises a retry
 * that is, from the reader's point of view, permanently one second away. Say what is actually
 * happening instead: counting down, or trying right now.
 */
export function retryPhrase(reconnectInSeconds: number | null): string {
  if (reconnectInSeconds === null) return '';
  return reconnectInSeconds > 0 ? ` — retrying in ${reconnectInSeconds}s` : ' — reconnecting now';
}
